/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ week: NonNullable<unknown>, total: NonNullable<unknown> }} Platform_Plan_Week_OfInputs */

const en_platform_plan_week_of = /** @type {(inputs: Platform_Plan_Week_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Week ${i?.week} of ${i?.total}`)
};

const pl_platform_plan_week_of = /** @type {(inputs: Platform_Plan_Week_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tydzień ${i?.week} z ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Week {week} of {total}" |
*
* @param {Platform_Plan_Week_OfInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_plan_week_of = /** @type {((inputs: Platform_Plan_Week_OfInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Plan_Week_OfInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_plan_week_of(inputs)
	return en_platform_plan_week_of(inputs)
});